import React from "react";
import { NumericFormat } from "react-number-format";
import { Controller } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";

const NumberInput = ({
  name,
  theme,
  placeholder,
  control,
  errors,
  required,
  type,
  title,
}: any) => {
  const InputStyles = {
    input: {
      border: 0,
      borderRadius: 0,
      boxShadow: "none",
      margin: "0 auto",
      outline: "none",
      padding: `${theme?.to_rem("16px")} 0`,
      transition: "0.3s",
      width: "100%",
      marginTop: "10px",
    },
    prefix: {
      display: "flex",
      alignItems: "center",
      borderBottom: `1px solid ${theme?.colors?.border_color}`,
    },
    span: {
      backgroundColor: `${theme?.primaryColor?.concat("1a")}`,
      padding: `${theme?.to_rem("6px")} ${theme?.to_rem("12px")}`,
      marginRight: `${theme?.to_rem("8px")}`,
      borderRadius: "0.4rem",
      fontWeight: 600,
    },
  };

  return (
    <div style={{ marginBottom: "20px" }}>
      <Controller
        control={control}
        rules={{
          required: required ? `${placeholder} is required` : false,
          pattern: type === "tel" ? {
                  value: /^0/i,
            message: "Please enter a valid phone number 08139******"
          } : undefined,
          minLength:type === "tel" ? {
                  value: 11,
            message: "Please enter a valid phone number 08139******"
          }: undefined
        }}
        name={name}
        render={({ field: { onChange, value } }) => (
          <div style={InputStyles.prefix}>
            {(type === "number" && title === "Amount") && <span style={InputStyles.span}>&#8358;</span>}
            {type === "tel" && <span style={InputStyles.span}>+234</span>}
            <NumericFormat
              thousandSeparator={title === "Amount" ? true : false}
              allowNegative={false}
              allowLeadingZeros={type === "tel" ? true : false}
              type="tel"
              style={InputStyles.input}
              placeholder={placeholder}
              value={value}
              onChange={onChange}
              maxLength={type === "tel" ? 11 : undefined}
            />
          </div>
        )}
      />
      <ErrorMessage
        errors={errors}
        name={name}
        as="span"
        className="error-form"
      />
    </div>
  );
};

export default NumberInput;
